require('./signup-free-template.html');
require('./signup-paid-template.html');

exports.inject = function(module) {
  module.config(['$routeProvider', function($routeProvider) {
   $routeProvider.when('/signup/:type/free', {
      templateUrl: 'signup-free-template.html',
      controller: 'SignupController',
      loginLayout: true,
    });
    $routeProvider.when('/signup/:type/:id', {
      templateUrl: 'signup-paid-template.html',
      controller: 'SignupController',
      loginLayout: true,
    });
  }]);
  module.controller('SignupController', [
    '$scope', '$routeParams', '$timeout', '$location', 'Auth', 'Plan', '$window', '$document', '$sce', 
    exports.controller
  ]);
};

exports.controller = function($scope, $routeParams, $timeout, $location, Auth, Plan, $window, $document, $sce) {
  $scope.MODEL = {
    plan: 75 //$routeParams.signupType == 'free-plan' ? 14 : 15
  };

  function init () {
    // Set years.
    var year = (new Date()).getFullYear();
    var years = [];

    for (var i=0; i<=20; i++){
      years.push(year+i);
    }
    $scope.years = years;

    // Set plan id.
    if ($routeParams.id) {
      $scope.MODEL = {
        plan: $routeParams.id
      };
      Plan.getPlanInfo($routeParams.id).then(
        function(response) {
          if (response){
            var data = Plan.info();
            $scope.planDescription = data.description;
            $scope.planName = data.name;
            $scope.planPrice = data.price;
          }
        }
      );
    }
  }

  init();
  
  $scope.validate = function($form) {
    var errors = [], form = $document[0].forms[$form.$name], msgs = {
      "email": function(field, value) {
        return "\""+value+"\" doesn't look like a valid email!";
      },
      "required": function(field) {
        if(field=='termsofservice'){
          return 'You need to accept the <a href="/terms-service" target="_new">Terms of Service</a>.';
        }
        var label = angular.element(form[field]).attr('placeholder');
        return label+" is required!";
      }
    };
    var addError = function(errorType, item){
      errors.push( $sce.trustAsHtml(msgs[errorType](item.$name, item.$viewValue)) );
    };

    for(var err in $form.$error) {
      $form.$error[err].forEach(addError.bind(null, err));
    }

    $scope.formErrorMessages = errors;

    $window.signform = $form;
    return !errors.length;
  };

  $scope.signupSubmit = function($event) {
    $event.preventDefault();
    $scope.errorMessage = false;
    Auth.signup($scope.MODEL).then(
      function() {
        // Update Google Analytics data.
        
        Plan.getPlanInfo($scope.MODEL.plan).then(
       
          function(response) {
            if (response){
                console.log("not doing analytics anymore");
	      /*
              var data = Plan.info();
              if (data.price > 0) {

            
                $window.ga('send', 'event', 'Form', 'New User', 'Paid Signup');
                console.log("reported conversion event");
                $window.goog_report_paid_conversion();
                console.log("reported paid conversion adwords event");
              }
              else {
                
                $window.ga('send', 'event', 'Form', 'New User', 'Free Signup');
                console.log("reported conversion event");
                $window.goog_report_free_conversion();
                console.log("reported free conversion adwords info");
              }
		*/
            }
          }
        );
        $window.open('/app/#/dashboard/add', '_parent');
      },
      function(response) {
        if(!response.data.success) {
          $scope.errorMessage = response.data.msg;
        }
      }
    );
  };
};



/*****************
 ** WEBPACK FOOTER
 ** ./app/authorization/signup-controller.js
 ** module id = 296
 ** module chunks = 0
 **/